// extracted by mini-css-extract-plugin
export default {"root":"PrepCardItem_root__z393F","title":"PrepCardItem_title__4BC0i"};